<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="disclaimer">
<h1>Disclaimer</h1>
<p>This is a work of fiction. Names, characters, businesses, places, events, locations and incidents are either the products of the author’s imagination or used in a fictitious manner. Any resemblance to actual persons, living or dead, or actual events is purely coincidental. However, this story is based on authentic historical facts and current events.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?671f2b7c